import { Location } from "@insite/client-framework/Components/SpireRouter";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { GetSignInUrl } from "@rightstore/Services/RightShipPortalSettingsService";
import { useState } from "react";

const mapStateToProps = (state: ApplicationState) => ({
    selectedVariant: getProductState(state, state.pages.productDetails.selectedProductId),   
});

interface OwnProps {
    currentLocation: Location;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>
/**
 * This component will return a date localized to the language of the session with predefined RightSTORE options. * 
 */
const getSignInUrl = async ({ currentLocation, selectedVariant }: Props) => {      
    let _signInUrl = "";
    await GetSignInUrl().then((getSignInUrlResponse) => { _signInUrl = getSignInUrlResponse });
    // if we received the URL then add the redirect URL
    if (_signInUrl !== '') {
        // Add the SKU 
        let productNumber = '';
        if (selectedVariant != null && selectedVariant != null && selectedVariant.value != null) {
            productNumber = selectedVariant.value.productNumber;
        }
        _signInUrl = _signInUrl.replace('{PRODUCTNUMBER}', productNumber);

        // Add the redirect url
        let returnUrl = "";
        if(window){
            returnUrl = `${window.location.protocol}//${window.location.hostname}${currentLocation.pathname}${currentLocation.search}`;
        }
        _signInUrl = _signInUrl.replace("{RETURNURL}", encodeURIComponent(returnUrl));
    }

    return _signInUrl
};

export default getSignInUrl;